/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import {
  Button,
  Card,
  CardText,
  CardTitle,
  Col,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
} from "reactstrap";
import NoDataFound from "../../components/NoDataFound/NoDataFound";
import { Link } from "react-router-dom";

import { BiDotsVerticalRounded, BiExitFullscreen } from "react-icons/bi";
import { MdLocationOn } from "react-icons/md";
import { FiBriefcase, FiShare2 } from "react-icons/fi";
import AdsImage from "./AdsImage";
import { AiFillStar, AiOutlineStar } from "react-icons/ai";

const GridView = ({ data, addToRoute }) => {
  const [dropdownMenuOpen, setMenuOpen] = useState();
  const [link, setLink] = useState("");
  const [showShareModal, setShowShareModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [mkmID, setMkmId] = useState();
  
  let name = "Tzadikim";

  const share = (id, poi) => {
    var data;
    if (name === "Tzadikim") {
      data = `${window?.location?.protocol}//${window?.location?.host}/category-details/${id}/${poi}`;
      setLink(data);
    } else {
      data = `${window?.location?.protocol}//${window?.location?.host}/category-detail/${id}/${poi}`;
      setLink(data);
    }
    setShowShareModal(true);
  };

  

  const createImage = (content, name, type) => {
    console.log(content, "filecontent");
    console.log(name, "filecontent");
    console.log(type, "filecontent");
    const decodeData = atob(content);
    console.log(decodeData, "decode data here :");
  };

  return (
    <div className="grid_view">
      <Row>
        {data?.length === 0 || data === undefined ? (
          <NoDataFound />
        ) : (
          data.map((item, index) => (
            <Col xxl="4" lg="6" md="12" key={index} className="mb-4">
              <Card body>
                <div className="card_header">
                  {item?.userFavorite === true ? (
                    <Button
                      className="favourite_fill_icon"
                    >
                      <AiFillStar size={20} />
                    </Button>
                  ) : (
                    <Button
                      className="favourite_icon"
                    //   onClick={() =>
                    //     addToFavorite(
                    //       place?.tzadikimID
                    //         ? { tzadikimID: place?.tzadikimID }
                    //         : { mkmID: place?.mkmID },
                    //       place?.userFavorite
                    //     )
                    //   }
                    >
                      <AiOutlineStar size={20} />
                    </Button>
                  )}
                  <div className="right_section">
                    {name === "Tzadikim" ? (
                      <Link
                        to={`/category-detail/?tzadikimId=${item?.tzadikimID}&cor=${item?.poi}`}
                      >
                        <CardTitle tag="h5" title={item?.title}>
                          {item?.title}
                        </CardTitle>
                        <CardText>{item?.adType}</CardText>
                      </Link>
                    ) : (
                      <Link
                        to={`/category-detail/?MkmId=${item?.mkmID}&cor=${item?.poi}`}
                      >
                        <CardTitle tag="h5" title={item?.title}>
                          {item?.title}
                        </CardTitle>
                      </Link>
                    )}
                    <Dropdown
                      className="moreInfo"
                      toggle={() =>
                        setMenuOpen(index === dropdownMenuOpen ? null : index)
                      }
                      isOpen={index === dropdownMenuOpen}
                    >
                      <DropdownToggle>
                        <BiDotsVerticalRounded size={20} />
                      </DropdownToggle>
                      <DropdownMenu>
                        <DropdownItem>
                          <Link
                            to={`/along-the-way-to-here/${item?.poi}`}
                            className="breadcrumb_item1"
                          >
                            Along the way to here
                          </Link>
                        </DropdownItem>
                        <DropdownItem>Report suggestion</DropdownItem>
                      </DropdownMenu>
                    </Dropdown>
                  </div>
                </div>
                <div className="card_bottom">
                  <Button
                    onClick={() =>
                      createImage(
                        item?.fileContent,
                        item?.fileName,
                        item?.fileType
                      )
                    }
                  >
                    <FiShare2 size={20} />
                  </Button>
                  <div className="right_section">
                    <CardText>{item?.mkmId + " " + item?.poi}</CardText>
                    <MdLocationOn className="location_icon" size={18} />
                  </div>
                  <AdsImage
                    fileContent={item?.fileContent}
                    fileType={item?.fileType}
                    fileName={item?.fileName}
                  />
                </div>
                <div className="card_footer">
                  <Link
                    to={`/explore-near-by/${item?.poi}`}
                    className="btn explore"
                  >
                    <BiExitFullscreen className="explore_icon" />
                    Explore Near By
                  </Link>
                  {name === "Tzadikim" ? (
                    <Link
                      to={`/category-detail/?tzadikimId=${item?.mkmId}&cor=${item?.poi}`}
                      className="btn viewmore"
                    >
                      View More
                    </Link>
                  ) : (
                    <Link
                      to={`/category-detail/?MkmId=${item?.mkmId}&cor=${item?.poi}`}
                      className="btn viewmore"
                    >
                      View More
                    </Link>
                  )}
                  <Button
                    className="btn addroute"
                    onClick={() => addToRoute(item?.mkmId, item)}
                  >
                    <FiBriefcase className="addroute_icon" />
                    Add to Route
                  </Button>
                </div>
              </Card>
            </Col>
          ))
        )}
      </Row>
    </div>
  );
};

export default GridView;
